<template>
  <div>
    <div class="filter-container" v-sticky-component="'sticky-landing'">
      <!--   Player team   -->
      <div
        class="filter-item vertical-align-middle player-team"
        v-if="hasPlayerNationalTeam && hasPlayerClubSeasons && $route.name === 'player'"
      >
        <span @click="setIsPlayerNationalTeam(false)" class="is-clickable" style="margin-right: 12px;">CLUB</span>
        <BSwitch :value="isPlayerNationalTeam" passive-type="is-primary" @input="setIsPlayerNationalTeam" />
        <span class="is-clickable" @click="setIsPlayerNationalTeam(true)">SELECCIÓN NACIONAL</span>
      </div>
      <!-- Seasons -->
      <div class="filter-item vertical-align-middle">
        <span class="filter-item-name"> {{ $t('filter.tournament') }}: </span>
        <BSelect
          class="is-inline-block vertical-align-middle"
          placeholder="Selecciona uno"
          :value="seasonId"
          @input="onSeasonChanged"
        >
          <option v-for="season in seasons" :key="season.id" :value="season.id">
            {{ season.name }}
          </option>
        </BSelect>
      </div>
      <!-- locality -->
      <div class="filter-item">
        <span class="filter-item-name"> {{ $t('filter.locality') }}: </span>
        <BSelect class="is-inline-block  vertical-align-middle" v-model="playingAs" @input="onPlayingAsChanged">
          <option v-for="(playing, index) in playingType" :key="index" :value="playing.playingAs">
            {{ $t(playing.label) }}
          </option>
        </BSelect>
      </div>
      <!-- Match result -->
      <div class="filter-item" style="vertical-align: middle;">
        <span class="filter-item-name"> {{ $t('filter.results') }}: </span>
        <div :key="resultsKey" class="is-inline-block match-results-options vertical-align-middle">
          <BCheckbox :native-value="1" class="vertical-align-middle" v-model="results">
            {{ $t('filter.won') }}
          </BCheckbox>
          <BCheckbox :native-value="3" class="vertical-align-middle" v-model="results">
            {{ $t('filter.tied') }}
          </BCheckbox>
          <BCheckbox ref="lost" :native-value="2" class="vertical-align-middle" v-model="results">
            {{ $t('filter.lost') }}
          </BCheckbox>
        </div>
      </div>
      <!-- Games -->
      <div id="dropDownGames" class="filter-item vertical-align-middle games">
        <div>
          <span class="filter-item-name"> {{ $t('filter.games') }}: </span>
        </div>
        <div>
          <BDropdown aria-role="list" :close-on-click="false" scrollable expanded :disabled="!this.selectedGames">
            <template #trigger>
              <div class="filter-item__games selected" :style="selectedGameStyle">
                <div class="text">{{ selectedGamesText }}</div>
                <div class="icn-arrow">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem v-for="game of availableGames" :value="game.id" :key="game.id" aria-role="listitem">
              <div class="available-game" @click.stop="onAvailableGameClicked">
                <div>
                  <BCheckbox class="vertical-align-middle" v-model="game.isSelected">
                    {{ `${game.roundAbbreviation} vs ${game.rivalTeam.colloquial_name}` }}
                  </BCheckbox>
                </div>
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
      </div>
      <!-- Time -->
      <div class="filter-item">
        <span class="filter-item-name"> {{ $t('filter.time_lapse') }}: </span>
        <div :key="sectionsKey" style="display: inline-block;">
          <div style="display: inline-block;">
            <BField>
              <BCheckboxButton :native-value="1" v-model="sections">
                0-15
              </BCheckboxButton>
              <BCheckboxButton :native-value="2" v-model="sections">
                16-30
              </BCheckboxButton>
              <BCheckboxButton :native-value="3" v-model="sections">
                31-45
              </BCheckboxButton>
            </BField>
          </div>
          <div style="display: inline-block; margin-left: 10px;">
            <BField>
              <BCheckboxButton :native-value="4" v-model="sections">
                45-60
              </BCheckboxButton>
              <BCheckboxButton :native-value="5" v-model="sections">
                61-75
              </BCheckboxButton>
              <BCheckboxButton :native-value="6" v-model="sections">
                76-90
              </BCheckboxButton>
            </BField>
          </div>
        </div>
      </div>
      <!-- Button to apply selected options -->
      <!--      <div class="filter-item">-->
      <!--        <BButton type="is-primary" @click="setUpAndEmitNewFilter">Aplicar Filtros</BButton>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'buefy/dist/esm/dropdown';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'NavBarFilter',
  components: {
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      sections: [1, 2, 3, 4, 5, 6],
      results: [1, 2, 3],
      playingAs: null,
      availableGames: [],
      playingType: [
        {
          playingAs: null,
          label: 'filter.all',
        },
        {
          playingAs: 1,
          label: 'filter.home',
        },
        {
          playingAs: 2,
          label: 'filter.away',
        },
      ],
      resultsKey: 0,
      sectionsKey: 0,
      selectedGameStyle: { width: 'max-content', 'white-space': 'nowrap' },
      dropDownResizeObserver: null,
    };
  },
  created() {
    this.setSections();
    this.setResults();
    this.setPlayingAs();
  },
  computed: {
    ...mapState('filterGeneral', [
      'hasPlayerNationalTeam',
      'isPlayerNationalTeam',
      'nationalSeasons',
      'hasPlayerClubSeasons',
    ]),
    ...mapState('playersGeneral', ['playerSeasons']),
    ...mapGetters('filterGeneral', {
      seasons: 'getSeasons',
      seasonId: 'getSeasonId',
      stadisticId: 'getStadisticId',
      games: 'availableGames',
    }),
    selectedGames() {
      return this.availableGames.reduce((accumulator, game) => {
        if (game.isSelected) {
          // eslint-disable-next-line no-param-reassign
          accumulator++;
        }
        return accumulator;
      }, 0);
    },
    selectedGamesText() {
      if (this.selectedGames === 1) {
        const activeGame = this.availableGames.find(game => game.isSelected);
        return `${activeGame.roundAbbreviation} vs ${activeGame.rivalTeam.colloquial_name}`;
      } else if (!this.selectedGames) {
        return `partidos no disponibles`;
      }
      return `${this.selectedGames} ${this.$t('filter.selected')}`;
    },
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(newValue) {
        let analysisType = 0;
        let teamId = 0;
        if (newValue === 'player') {
          analysisType = 1;
          teamId = 0;
        } else {
          analysisType = 2;
          teamId = Number(this.$route.params.teamId);
        }
        this.setAnalysisType(analysisType);
        this.setTeamId(teamId);
      },
    },
    sections(newValue, oldValue) {
      if (newValue.length === 0) {
        this.sections = oldValue;
        this.sectionsKey++;
      }
      this.setSections();
    },
    results(newValue, oldValue) {
      if (newValue.length === 0) {
        this.results = oldValue;
        this.resultsKey++;
      }
      this.setResults();
    },
    playingAs() {
      this.setPlayingAs();
    },
    games(newValue) {
      this.availableGames = [...newValue] || [];
      this.fillSelectedGames();
    },
    availableGames() {
      const gamesDropDown = document.querySelector('.dropdown-content');
      if (window.ResizeObserver) {
        if (gamesDropDown && !this.dropDownResizeObserver) {
          this.dropDownResizeObserver = new ResizeObserver(() => {
            if (gamesDropDown.clientWidth !== 0) {
              this.selectedGameStyle.width = `${gamesDropDown.clientWidth + 20}px`;
              this.selectedGameStyle['justify-content'] = 'space-between';
            }
          });
        }
        this.dropDownResizeObserver.observe(gamesDropDown);
      } else {
        throw new Error('Resize observer not supported!');
      }
    },
    isPlayerNationalTeam(newValue) {
      this.updateSeasons({ seasons: this.playerSeasons[newValue ? '1' : '0'] });
    },
  },
  methods: {
    ...mapMutations('filterGeneral', [
      'setAnalysisType',
      'setSelectedGamesIds',
      'setTeamId',
      'setIsPlayerNationalTeam',
    ]),
    ...mapActions('filterGeneral', ['updateSeasons']),
    /**
     * @author José Rafael Gutierrez
     * Set property sections in filterGeneral module.
     * @return void
     */
    setSections() {
      this.$store.commit('filterGeneral/setSections', this.sections);
      this.$emit('sectionsChanged', this.sections);
    },
    /**
     * @author José Rafael Gutierrez
     * Set property results in filterGeneral module.
     * @return void
     */
    setResults() {
      try {
        this.$store.commit('filterGeneral/setResults', this.results);
        this.$emit('resultsChanged', this.results);
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * @author José Rafael Gutierrez
     * Set property playingAs in filterGeneral module.
     * @return void
     */
    setPlayingAs() {
      try {
        this.$store.commit('filterGeneral/setPlayingAs', this.playingAs);
      } catch (err) {
        console.error(err);
      }
    },
    fillSelectedGames() {
      const selectedGamesIds = this.availableGames.reduce((accumulator, game) => {
        if (game.isSelected) {
          accumulator.push(game.id);
        }
        return accumulator;
      }, []);
      this.setSelectedGamesIds(selectedGamesIds);
    },
    onAvailableGameClicked() {
      setTimeout(() => {
        this.fillSelectedGames();
      }, 100);
    },
    async onSeasonChanged(value) {
      if (this.$store.getters['filterGeneral/getSeasonId'] !== value) {
        this.$store.commit('filterGeneral/setSeasonId', value);
        const selectedSeason = this.seasons.find(season => season.id === value);
        this.$store.dispatch('playersGeneral/cleanData');
        await this.$store.dispatch('playersGeneral/checkStateSummary', {
          seasonNumber: Number(value),
          playerId: Number(this.$route.params.playerId),
        });
        if (selectedSeason) {
          this.$store.commit('filterGeneral/setSeasonType', selectedSeason.type);
        }
      }
    },
    /**
     * @author Cristhian Gómez
     * Set property stadisticId in filterGeneral module.
     * @return void
     */
    onStadisticChanged(value) {
      this.$store.commit('filterGeneral/setStadisticId', value);
      this.$emit('statisticsChanged', value);
    },
    onPlayingAsChanged(value) {
      let type = this.playingType.find(p => p.playingAs == value).label;
      this.$emit('playingAsChanged', type);
    },
  },
};
</script>

<style scoped lang="scss">
.filter-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: left;
}

.filter-item {
  vertical-align: middle;
  margin: 5px;
  flex-grow: 0;
  font-size: 15px;
  color: #808285;
}

.filter-item-name {
  margin-right: 0;
  vertical-align: middle;
  text-transform: uppercase;
}

.vertical-align-middle {
  vertical-align: middle;
}

.match-results-options {
  border-radius: 6px;
  border: solid 1px #d8d8d8;
  background-color: #ffffff;
  padding: 5px 12px;
  display: inline-flex !important;
}

@media screen and (max-width: 768px) {
  .filter-container {
    justify-content: center;
  }

  .filter-item {
    text-align: center;
  }
}
.games {
  display: flex;
  align-items: center;
  justify-content: center;

  & > div:first-child {
    margin-right: 0.2em;
  }
}

.selected {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 4px;
  border: solid 1px #dbdbdb;
  padding: 0.4em;
  cursor: pointer;

  & > .icn-arrow {
    margin-left: 0.6em;
  }
}

.available-game {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 0.3em;

  & > div {
    min-width: 155px;
    display: flex;
    justify-content: flex-start;
  }
}
</style>

<style lang="scss">
.filter-container {
  & div.filter-item a.dropdown-item {
    padding: 0.375rem 0.2rem;
  }

  & .dropdown-item.is-active,
  .dropdown .dropdown-menu .has-link a.is-active,
  button.dropdown-item.is-active {
    background-color: white;
    color: #4a4a4a;
  }

  & div.dropdown-content {
    width: max-content;
  }

  @media screen and (max-width: 1023px) {
    .dropdown.is-mobile-modal > .dropdown-menu {
      position: absolute !important;
      width: max-content;
      max-height: calc(100vh - 120px);
      bottom: unset !important;
      top: 100% !important;
      left: 0 !important;
      right: unset !important;
      z-index: 50 !important;
      transform: unset !important;
    }

    .dropdown-content {
      background-color: white;
      border-radius: 4px;
      -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1) !important;
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1) !important;
      padding-bottom: 0.5rem;
      padding-top: 0.5rem;
      border: solid 1px #dbdbdb;
    }

    .dropdown.is-mobile-modal > .dropdown-menu > .dropdown-content > .dropdown-item,
    .dropdown .dropdown-menu .has-link .dropdown.is-mobile-modal > .dropdown-menu > .dropdown-content > a,
    .dropdown.is-mobile-modal > .dropdown-menu > .dropdown-content > .has-link a {
      padding: 0.375rem 0.2rem;
    }
  }

  .dropdown.is-expanded.is-mobile-modal .dropdown-menu {
    max-width: max-content !important;
  }

  .dropdown .background {
    display: none !important;
  }
}
.player-team {
  display: flex;
  align-items: center;
}
</style>
